export default __webpack_public_path__ + "static/media/github.a0bd235f.svg";